import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Col, Grid, Row } from '@cian/ui-kit';
import * as React from 'react';
import { HeroBanner } from '../../../../components/MyHome/HeroBanner';

import { PageAside } from '../../../../components/PageAside';
import { Section } from '../../../../components/Section';
import { Wrapper } from '../../../../components/Wrapper';
import { EScrollingBlocks } from '../../../../constants/scrollingBlocks';
import { VIEWED_TIMEOUT } from '../../../../constants/viewedBlock';
import { trackOffersHistoryView } from '../../../../utils/teaser';
import { EstimationChartContainer } from '../../../EstimationChartContainer';
import { InfrastructureContainerLoad } from '../../../InfrastructureMapContainer';
import { MarketPriceContainer } from '../../../MarketPriceContainer';
import { MyHomeListingContainer } from '../../../MyHomeListingContainer';
import { OfferHistoryContainer } from '../../../OfferHistory/Desktop';
import { RateOurEstimationContainer } from '../../../RateOurEstimationContainer';
import { useScrollingRef } from '../../../Scrolling';
import { ValuationContentContainer } from '../../../ValuationContentContainer';
import { ViewAllReportContainer } from '../../../ViewAllReportContainer';
import { ServicesContainer } from '../../../ServicesContainer';
import { StatusList } from '../../../Status/containers/StatusList';
import { PrelandingContainer } from '../../../PrelandingContainer';
import { SubscribeWidgetContainer } from '../../../SubscribeWidget';

export const MyHomeDesktopView: React.FC = () => {
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const estimationChartRef = useScrollingRef(EScrollingBlocks.EstimationChart);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);

  return (
    <>
      <HeroBanner>
        <MyHomeListingContainer />
      </HeroBanner>
      <Wrapper>
        <ValuationContentContainer>
          <Grid>
            <Row>
              <Col xs={9}>
                <Section marginTop={60}>
                  <MarketPriceContainer refWrapper={marketPriceRef} />
                  <RateOurEstimationContainer />
                </Section>
                <Section marginTop={60}>
                  <EstimationChartContainer refWrapper={estimationChartRef} />
                </Section>
                <Section marginTop={80}>
                  <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackOffersHistoryView}>
                    <OfferHistoryContainer refWrapper={offersHistoryRef} />
                  </ActionAfterViewObserver>
                </Section>
                <Section marginTop={80}>
                  <InfrastructureContainerLoad refWrapper={infrastructureRef} />
                </Section>
              </Col>
              <Col xs={3}>
                <PageAside>
                  <ViewAllReportContainer />
                  <ServicesContainer />
                </PageAside>
              </Col>
            </Row>
          </Grid>
        </ValuationContentContainer>
      </Wrapper>
      <PrelandingContainer />
      <StatusList />

      <SubscribeWidgetContainer />
    </>
  );
};

MyHomeDesktopView.displayName = 'DesktopView';
